module.exports = __webpack_public_path__ + "img/ico_calendar.511b2fbf.svg";